/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DeadLink,
    DeadLinkFromJSON,
    DeadLinkFromJSONTyped,
    DeadLinkToJSON,
} from './DeadLink';

/**
 * 校正結果
 * @export
 * @interface DeadLink200ResponseResultData
 */
export interface DeadLink200ResponseResultData {
    /**
     * サブタイトルに含まれる校正結果のリスト
     * @type {Array<DeadLink>}
     * @memberof DeadLink200ResponseResultData
     */
    subtitle: Array<DeadLink>;
    /**
     * リード文に含まれる校正結果のリスト
     * @type {Array<DeadLink>}
     * @memberof DeadLink200ResponseResultData
     */
    head: Array<DeadLink>;
    /**
     * 本文に含まれる校正結果のリスト
     * @type {Array<DeadLink>}
     * @memberof DeadLink200ResponseResultData
     */
    sentence: Array<DeadLink>;
}

export function DeadLink200ResponseResultDataFromJSON(json: any): DeadLink200ResponseResultData {
    return DeadLink200ResponseResultDataFromJSONTyped(json, false);
}

export function DeadLink200ResponseResultDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeadLink200ResponseResultData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'subtitle': ((json['subtitle'] as Array<any>).map(DeadLinkFromJSON)),
        'head': ((json['head'] as Array<any>).map(DeadLinkFromJSON)),
        'sentence': ((json['sentence'] as Array<any>).map(DeadLinkFromJSON)),
    };
}

export function DeadLink200ResponseResultDataToJSON(value?: DeadLink200ResponseResultData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'subtitle': ((value.subtitle as Array<any>).map(DeadLinkToJSON)),
        'head': ((value.head as Array<any>).map(DeadLinkToJSON)),
        'sentence': ((value.sentence as Array<any>).map(DeadLinkToJSON)),
    };
}

